// tslint:disable:ordered-imports
import { Component, Input } from "@angular/core";
import { Store } from "@ngrx/store";
import { Router } from "@angular/router";
import { TranslationType } from "../../../models/translation-type";
import { ChartModel } from "../../../models/chart-model";
import { NgModel } from "@angular/forms";
import { TranslationService } from "../../../services/translation.service";
import { TranslationTypesActions } from "../../../store/actions/translation-types.actions";
import { Subscription } from "rxjs/Subscription";
import { ITranslationTypes } from "./../../../store/actions/translation-types.actions";

@Component({
  selector: "app-translations-dashboard",
  templateUrl: "./translations-dashboard.component.html",
  styleUrls: ["./translations-dashboard.component.scss"],
})
export class TranslationsDashboardComponent {
  @Input() displayInTranslationPage = true;

  translations: ITranslationTypes;
  charts: ChartModel[];
  translationTypes: TranslationType[] = [];
  subscriptions: Subscription[] = [];
  languageSubscription: Subscription;
  colors = [{ backgroundColor: ["#4FB65C", "#CB0038"] }];
  toggleDisabled: boolean;
  nonSportType = ["Type", "Group", "Label"];
  metadatasType = [
    "City",
    "Country",
    "Venue",
    "Sponsor",
    "Player",
    "Broadcast type",
    "Keyword",
    "Category",
    "Federation",
  ];
  /**
   * Get all translation types from the store and generate charts
   * @param {Store<any>} store
   */
  constructor(
    private store: Store<any>,
    private translationService: TranslationService,
    private translationTypesActions: TranslationTypesActions,
    private router: Router
  ) {}

  ngOnInit() {
    this.subscriptions.map((sub) => sub.unsubscribe());

    // Get translation types from the store
    this.subscriptions.push(
      this.store
        .select("translationTypesState")
        .subscribe((translations: ITranslationTypes) => {
          this.charts = [];
          this.translations = translations;

          if (this.languageSubscription) {
            this.languageSubscription.unsubscribe();
          }

          this.languageSubscription = this.store
            .select("userState")
            .subscribe((user) => {
              // If the store is empty, call the API to retrieve the translation types
              if (
                this.translations.translationTypes.length === 0 ||
                (user &&
                  this.translations.translationTypes[0].languageId !==
                    user.currentLanguage.id)
              ) {
                if (user && user.currentLanguage) {
                  this.translationService
                    .getTranslationTypes(user.currentLanguage)
                    .subscribe((types: TranslationType[]) => {
                      this.translationTypesActions.setTranslationTypes(types);
                    });
                }
              } else {
                this.init(translations.translationTypes);
              }
            });
        })
    );
  }

  ngOnDestroy() {
    this.subscriptions.map((sub) => sub.unsubscribe());
    this.languageSubscription.unsubscribe();
  }

  init(translationTypes: TranslationType[]) {
    if (translationTypes && translationTypes.length) {
      this.translationTypes = translationTypes;
      if (!this.translations.filteredTranslationTypes) {
        this.translations.filteredTranslationTypes = translationTypes.filter(
          (t) => t.isDashboard
        );
      }
      this.drawCharts();
    }
  }

  drawCharts() {
    this.charts = [];
    this.translations.filteredTranslationTypes.forEach((type) => {
      this.charts.push(
        new ChartModel({
          id: type.id,
          title: type.value,
          labels: ["Translated", "Not translated"],
          data: [type.translated, type.total - type.translated],
          type: "pie",
          percentTranslated: type.percentTranslated,
          isDisplayed: true,
          isSportiveClassification:
            !this.nonSportType.includes(type.value) &&
            !this.metadatasType.includes(type.value),
          isMetadatasClassification: this.metadatasType.includes(type.value),
        })
      );
    });
    this.toggleDisabled = false;
  }

  translationTypeChanged(event) {
    this.drawCharts();
  }

  selectAllTranslationTypes(select: NgModel, values, event) {
    if (event.checked) {
      select.update.emit(values);
    } else {
      select.update.emit([]);
    }
    this.drawCharts();
  }

  alltranslationTypesSelected() {
    if (this.translations.filteredTranslationTypes && this.translationTypes) {
      return (
        this.translations.filteredTranslationTypes.length ===
        this.translationTypes.length
      );
    }
    return false;
  }

  chartClick(event: any, chartModel: ChartModel) {
    if (event.active && event.active.length > 0) {
      const chart = event.active[0]._chart;
      const activePoints = chart.getElementAtEvent(event.event);
      if (activePoints.length > 0) {
        // get the internal index of slice in pie chart
        const clickedElementIndex = activePoints[0]._index;
        const label = chart.data.labels[clickedElementIndex];
        // get value by index

        this.router.navigate(["", "translate", chartModel.id, label]);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/translate/translations-dashboard/translations-dashboard.component.ts